/**
 * Replaces placeholders in URIs with actual values
 * @param {string} uri - The URI string with placeholders
 * @param {Object} params - Object containing values to replace
 * @param {string|number} params.locationId - Location ID to replace :locationID or <locationid>
 * @param {string|number} params.organizationId - Organization ID to replace :organizationID or <organizationid>
 * @param {string|number} params.personId - Person ID to replace :personID or <personid>
 * @returns {string} - URI with placeholders replaced
 */
export function replaceUriPlaceholders(uri, params = {}) {
    if (!uri || typeof uri !== 'string') {
        return uri;
    }

    let processedUri = uri;

    // Replace location ID placeholders
    if (params.locationId) {
        const locationId = String(params.locationId);
        processedUri = processedUri.replace(/:locationID/gi, locationId);
        processedUri = processedUri.replace(/<locationid>/gi, locationId);
    }

    // Replace organization ID placeholders
    if (params.organizationId) {
        const organizationId = String(params.organizationId);
        processedUri = processedUri.replace(/:organizationID/gi, organizationId);
        processedUri = processedUri.replace(/<organizationid>/gi, organizationId);
    }

    // Replace person ID placeholders
    if (params.personId) {
        const personId = String(params.personId);
        processedUri = processedUri.replace(/:personID/gi, personId);
        processedUri = processedUri.replace(/<personid>/gi, personId);
    }

    return processedUri;
}

/**
 * Processes an array of cards/items and replaces URI placeholders in each
 * @param {Array} items - Array of objects with uri property
 * @param {Object} params - Object containing values to replace
 * @returns {Array} - Array of items with processed URIs
 */
export function processUriPlaceholders(items, params = {}) {
    if (!Array.isArray(items)) {
        return [];
    }

    return items.map(item => {
        if (!item.uri) {
            return item;
        }

        return {
            ...item,
            uri: replaceUriPlaceholders(item.uri, params)
        };
    });
}

